import React from 'react';
import { CellSkeleton } from '../common';

function OrdersListSkeleton() {
  return (
    <div>
      {Array.from({ length: 6 }, (_, i) => (
        <CellSkeleton key={i} showPriceSkeleton={false} />
      ))}
    </div>
  );
}

export default OrdersListSkeleton;
